import Box from '@zenbusiness/zui/Box';
import Paper from '@zenbusiness/zui/Paper';
import SnackbarContent from '@zenbusiness/zui/SnackbarContent';
import { styled } from '@zenbusiness/zui/styles';

export const PaperStyle = () => ({
  padding: '24px',
  margin: '24px auto',
  '&.MuiPaper-rounded': {
    borderRadius: '18px'
  }
});

export const SnackbarContentStyle = ({ theme }) => ({
  width: '250px',
  position: 'relative',
  margin: '-35px auto 0',
  backgroundColor: theme.palette.background.grey.main,
  color: theme.palette.text.primary,
  borderRadius: '12px',
  [theme.breakpoints.up('md')]: {},
  zIndex: 10,
  '& .MuiSnackbarContent-message': {
    margin: '0 auto',
    fontWeight: 'bold'
  }
});

export const WrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
});

export const PaperStyled = styled(Paper)(PaperStyle);
export const SnackbarContentStyled = styled(SnackbarContent)(SnackbarContentStyle);
export const Wrapper = styled(Box)(WrapperStyle);
